export const getTextEditor = ( state, id ) => {
  const item = state.textEditors.find( t => t.id === id )
  return {
    id,
    ...item
  }
}
export const getTextEditors = state => state.textEditors
export const getActiveTextEditor = state => state.activeTextEditor


// WEBPACK FOOTER //
// ./src/store/getters/textEditors.js